<template>
    <app-modal :modal-id="modalId" :modal-size="modalSize" :modal-alignment="modalAlignment" :modal-scroll="false" 
        :modal-body-class="'w-full max-w-full wizard-steps'" @close-modal="closeModal">
	
        <template slot="header">
            <h5 class="modal-title">
                {{ modalTitle }}
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close"
                @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
		<template slot="body">
			<div class="row">
                <div class="col-md-12 mt-8">
                    <student-list-with-course
                        :CourseId="CourseId"
                    ></student-list-with-course>
                </div>
            </div>
		</template>
    </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";


export default {
	name: "StudentListFornWizard",
	mixins: [FormMixin, ModalMixin],
	props: {
		modalId: String,
        CourseId: null,
        CourseName: null,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			formData:{},
			preloader: false,
            modalSize: 'extra-large',
            modalAlignment: 'top',
            // modalTitle: `Student List - ${this.rowData.course_name}`,
		};
	},
    computed: {
        modalTitle() {
            return `Student List - ${this.CourseName || ''}`;
        }
    },
	created() {
		if (this.selectedUrl) {
			this.preloader = true;
		}
	},
	methods: {

		afterSuccessFromGetEditData(response) {
			this.preloader = false;
		},
	},
};
</script>